export default __webpack_public_path__ + "static/alpaca-slider-second-image-798abdf506ac5c408b88afe591ccef57.jpg";